import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {IRootState} from 'app/shared/reducers';
import {setRegistrationData} from 'app/entities/registration/registration.reducer';
import 'app/entities/registration/registration.scss';
import {CaseType} from 'app/shared/model/enumerations/case-type.model';
import RegistrationButtons from './registration-buttons';

interface IPatientBabyInfoProps extends StateProps, DispatchProps {
  handlePreviousStep: () => void;
  handleNextStep: () => void;
  currentStep: number;
}

const PatientBabyInfo: React.FC<IPatientBabyInfoProps> = (props: IPatientBabyInfoProps) => {
  const {patient, patientCase} = props;

  

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    props.setRegistrationData({patient: {...patient, [name]: value}});
  };

  return (
    <div>
      <h2 className="mb-4">Add baby information</h2>
      <AvForm onValidSubmit={props.handleNextStep}>
        <Row>
          <Col md="12">
            <AvGroup>
              <Label for="babyFirstName">Baby&apos;s First Name</Label>
              <AvInput
                type="text"
                name="babyFirstName"
                id="babyFirstName"
                value={patient?.babyFirstName || ''}
                onChange={handleInputChange}
                placeholder="Add the baby's first name"
              />
            </AvGroup>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <AvGroup>
              <Label for="babyLastName">Baby&apos;s Last Name</Label>
              <AvInput
                type="text"
                name="babyLastName"
                id="babyLastName"
                value={patient?.babyLastName || ''}
                onChange={handleInputChange}
                placeholder="Add the baby's last name"
              />
            </AvGroup>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <AvGroup>
              <Label for="babyBirthDate">Baby&apos;s Date of Birth</Label>
              <AvInput
                type="date"
                name="babyBirthDate"
                id="babyBirthDate"
                value={patient?.babyBirthDate || ''}
                onChange={handleInputChange}
                placeholder="Add the baby's birth date"
              />
            </AvGroup>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <AvGroup>
              <Label for="babySex">Baby&apos;s Gender</Label>
              <AvInput type="select" name="babySex" id="babySex" value={patient?.babySex || ''}
                       onChange={handleInputChange}>
                <option value="">Select baby gender</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
              </AvInput>
            </AvGroup>
          </Col>
        </Row>
        <RegistrationButtons
          currentStep={props.currentStep}
          handlePreviousStep={props.handlePreviousStep}
        />
      </AvForm>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  patient: state.registration.entity.patient,
  patientCase: state.registration.entity.patientCase,
});

const mapDispatchToProps = {
  setRegistrationData,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PatientBabyInfo);
